import type { CartData } from '@components/Print/PrintKOTPrint';
import { resolveOnlineOrderServiceType } from '@constants/orderServiceType';
import type { OnlineOrder } from '@src/types/onlineOrder';

export function onlineOrderToPrintCart(order: OnlineOrder): CartData {
  const cart: CartData = {};

  order.cart.forEach((line, index) => {
    const key = line.id || `line-${index}`;
    cart[key] = {
      name: line.itemName.replace(/\s+/g, '-'),
      selected: line.quantity,
      selectedVariants: {
        value: line.unitPrice,
        label: line.variantSize ? `₹${line.unitPrice} · ${line.variantSize}` : `₹${line.unitPrice}`,
      },
      itemDescription: index === 0 && order.instructions ? order.instructions : undefined,
    };
  });

  return cart;
}

export function onlineOrderToPrintBill(order: OnlineOrder, restaurant: Record<string, unknown>) {
  return {
    cart: onlineOrderToPrintCart(order),
    orderSeqNo: order.orderSeqNo,
    orderId: order.id,
    uoId: order.orderCode,
    createdAt: new Date(order.placedAt).getTime(),
    tableNumber: order.tableOrRoom,
    tableDisplay: order.tableOrRoom,
    customerPhone: order.phone,
    itemsCost: order.itemsCost,
    gstData: order.gstData,
    gstBill: order.gstBill,
    serviceBill: order.serviceBill,
    totalCost: order.totalCost,
    isGstBill: order.isGstBill,
    discount: 0,
    restaurant,
    serviceType: resolveOnlineOrderServiceType(order.serviceType),
  };
}

export function onlineOrderToPrintKot(order: OnlineOrder) {
  return {
    cart: onlineOrderToPrintCart(order),
    tableNumber: order.tableOrRoom,
    createdAt: new Date(order.placedAt).getTime(),
    uoId: order.orderSeqNo ?? order.orderCode,
    orderId: order.id,
    serviceType: resolveOnlineOrderServiceType(order.serviceType),
    restaurantId: order.restaurantId,
    source: 'online-orders' as const,
    printType: 'online' as const,
    kotSessionId: `online_${order.id}`,
  };
}
